import React from 'react'
import { Card, LoadingOverlay, Flex, Text, Button, Table, Group, Menu, ActionIcon } from '@mantine/core'
import { IconPlus, IconDotsVertical, IconEye, IconPencil, IconTrash, IconUpload } from '@tabler/icons-react'
import ModalImportRate from './ModalImportRate'

const AirCourierPanel = ({
    loading,
    uniqueRates,
    handleAddNewRate,
    getCourierName,
    handleDetailRate,
    handleEditRate,
    handleDeleteRate,
    sourceCountry,
    destCountry,
    fetchAirCourierRates
}) => {
    const [importModalOpen, setImportModalOpen] = React.useState(false)
    return (
        <Card withBorder mt="sm" p="lg" radius="md" pos="relative">
            <LoadingOverlay visible={loading} />

            <Flex justify="space-between" align="center" mb="md">
                <Text fw={700}>Air Courier Rates</Text>
                <Group>
                    <Button
                        leftSection={<IconUpload size={16} />}
                        onClick={() => window.open('https://docs.google.com/spreadsheets/d/13tMyZVNe3j-hnGREjiiCZ7leabDxjGO0/edit?gid=745881465#gid=745881465', '_blank')}
                        variant="light"
                        color="blue"
                        radius="lg"
                        size='xs'
                    >
                        Download Excel (.xlsx) template here
                    </Button>
                    <Button
                        leftSection={<IconUpload size={16} />}
                        onClick={() => setImportModalOpen(true)}
                        variant="light"
                        color="red"
                    >
                        Upload Bulk from Excel
                    </Button>
                    <Button
                        leftSection={<IconPlus size={16} />}
                        onClick={handleAddNewRate}
                        color="red"
                    >
                        Add New Rates
                    </Button>
                </Group>
            </Flex>

            <ModalImportRate
                opened={importModalOpen}
                onClose={() => setImportModalOpen(false)}
                sourceCountry={sourceCountry}
                destCountry={destCountry}
                onSuccess={fetchAirCourierRates}
            />

            {uniqueRates.length === 0 ? (
                <Text c="dimmed" ta="center" py="xl">No Air Courier rates found for this route.</Text>
            ) : (
                <Table striped highlightOnHover withTableBorder withColumnBorders>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Courier</Table.Th>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>Origin</Table.Th>
                            <Table.Th>Destination</Table.Th>
                            <Table.Th>Remarks</Table.Th>
                            <Table.Th w={120}>Action</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {uniqueRates.map((rate) => (
                            <Table.Tr key={rate.id}>
                                <Table.Td fw={500}>{getCourierName(rate.attributes.courier_id)}</Table.Td>
                                <Table.Td>{rate.attributes.name || '-'}</Table.Td>
                                <Table.Td>{rate.attributes.origin?.name || '-'}</Table.Td>
                                <Table.Td>{rate.attributes.destination?.name || '-'}</Table.Td>
                                <Table.Td>{rate.attributes.remarks || '-'}</Table.Td>
                                <Table.Td>
                                    <Group gap="xs">
                                        <Menu shadow="md" width={120}>
                                            <Menu.Target>
                                                <ActionIcon variant="subtle" color="gray">
                                                    <IconDotsVertical size={16} />
                                                </ActionIcon>
                                            </Menu.Target>
                                            <Menu.Dropdown>
                                                <Menu.Item
                                                    leftSection={<IconEye size={14} />}
                                                    onClick={() => handleDetailRate(rate)}
                                                >
                                                    Detail
                                                </Menu.Item>
                                                <Menu.Item
                                                    leftSection={<IconPencil size={14} />}
                                                    onClick={() => handleEditRate(rate)}
                                                >
                                                    Edit
                                                </Menu.Item>
                                                <Menu.Item
                                                    leftSection={<IconTrash size={14} />}
                                                    color="red"
                                                    onClick={() => handleDeleteRate(rate)}
                                                >
                                                    Delete
                                                </Menu.Item>
                                            </Menu.Dropdown>
                                        </Menu>
                                    </Group>
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            )}
        </Card>
    )
}

export default AirCourierPanel
